<template>
    <v-app>
        <LoginModal />

        <Navbar />

        <v-main class="myBackground">
            <router-view />
        </v-main>
    </v-app>
</template>

<script>
import Navbar from "./components/shared/Navbar";
import LoginModal from "./components/shared/LoginModal";

export default {
    name: "App",
    components: {
        Navbar,
        LoginModal,
    },
    data: function() {
        return {
            connection: null,
            datas: "",
        };
    },
    // mounted() {
    //   window.Echo.channel('home').listen('DisplayKitchen', (data) => {
    //       this.datas = data
    //   });
    // }
};
</script>

<style scope>
.myBackground {
    background: url("./assets/Homepagebg5.png");
}
</style>
